import { styled } from 'styled-components';

export const HeadingWrapper = styled.h3`
  padding-top: 2rem;
  font-size: 22px;
`;

export const PageHeadingWrapper = styled.h2`
  font-size: 28px;
  margin-bottom: 0;
`;

export const SpacingWrapper = styled.p`
  padding-top: 1rem;
`;
